import { useState, useCallback } from 'react';
import { PanInfo } from 'framer-motion';

interface UseSwipeOptions {
  itemCount: number;
  isMobile?: boolean;
  swipeThreshold?: number;
  velocityThreshold?: number;
}

export const useSwipe = ({ itemCount, isMobile = false, swipeThreshold = 40, velocityThreshold = 0.2 }: UseSwipeOptions) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % itemCount);
  }, [itemCount]);

  const goToPrev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + itemCount) % itemCount);
  }, [itemCount]);

  const goToIndex = useCallback((index: number) => {
    if (index >= 0 && index < itemCount) {
      setCurrentIndex(index);
    }
  }, [itemCount]);

  const handleDragEnd = useCallback((_event: unknown, info: PanInfo) => {
    if (!isMobile || itemCount <= 1) return;

    const swipeDistance = Math.abs(info.offset.x);
    const swipeVelocity = Math.abs(info.velocity.x);

    const shouldSwipe = swipeDistance > swipeThreshold || swipeVelocity > velocityThreshold;

    if (shouldSwipe) {
      if (info.offset.x > 0 || info.velocity.x > 0) {
        goToPrev();
      } else {
        goToNext();
      }
    }
  }, [isMobile, itemCount, swipeThreshold, velocityThreshold, goToNext, goToPrev]);

  return {
    currentIndex,
    goToNext,
    goToPrev,
    goToIndex,
    handleDragEnd
  };
};

